import { App } from 'ionic-angular';
import { ContentPage } from '../../page.interface';
import { DataSource } from '../../interfaces/data-source.interface';
import { DataSourceConfig } from '../../interfaces/data-source-config.interface';
import { FilterOutput } from '../../interfaces/filter-outpt.interface';
import { FiltersConfig } from '../../interfaces/filters-config.interface';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SellionsCalendarEvent } from '../../interfaces/sellions-calendar-event.interface';
import { SellionsData } from '../../interfaces/sellions-data.interface';

@Injectable()
export class DataViewDataSource implements DataSource {
  public eventLayout: string;
  private config: DataSourceConfig = {} as DataSourceConfig;
  private readonly baseUrl = this.env.engineUrl + 'api/data-view/';
  private _filters: FilterOutput[];

  constructor(private app: App, @Inject('env') private env, private http: HttpClient) {}

  public get filters(): FilterOutput[] {
    return this._filters;
  }

  public getData(authToken?: string): Promise<SellionsData[]> {
    let headers = new HttpHeaders().set('Authorization', `Bearer ${authToken}`);
    return this.http
      .get<ContentPage>(this.baseUrl + this.config.params.dataViewName, { headers })
      .map((data) => this.mapToSellionsData(data.content))
      .toPromise();
  }

  private mapToSellionsData(data: any[]): SellionsData[] {
    return data.map((d) => ({
      ...d,
      displayComponent: this.config.displayComponent,
      displayComponentData: { d, title: d[this.config.params.titleColumn] },
      dataSource: this,
    }));
  }

  public getEvents(): Promise<SellionsCalendarEvent[]> {
    return this.http
      .get<ContentPage>(this.baseUrl + this.config.params.dataViewName)
      .map((data) => this.mapToSellionsCalendarEvents(data.content))
      .toPromise();
  }

  private mapToSellionsCalendarEvents(events: any[]): SellionsCalendarEvent[] {
    return events.map((event) => ({
      displayComponent: this.config.displayComponent,
      displayComponentData: { event, title: event[this.config.params.titleColumn] },
      dateFrom: event[this.config.params.startDateColumn],
      dateTo: event[this.config.params.endDateColumn],
      dataSource: this,
    }));
  }

  public filter(filters: FilterOutput[], authToken?: string, searchQuery?: string): Promise<SellionsData[]> {
    let params = new HttpParams();
    this._filters = filters;
    filters.forEach((filter) => (params = params.append(filter.column, JSON.stringify(filter))));
    if (!!searchQuery.length) {
      params = params.append('searchQuery', searchQuery);
    }
    let headers = new HttpHeaders().set('Authorization', `Bearer ${authToken}`);
    return this.http
      .get<ContentPage>(this.baseUrl + this.config.params.dataViewName, { params, headers })
      .map((data) => this.mapToSellionsData(data.content))
      .toPromise();
  }

  public search(query: string, authToken?: string): Promise<SellionsData[]> {
    return this.filter([], authToken, query);
  }

  public async detailsOnClick(event: SellionsCalendarEvent) {
    return this.app.getRootNav().push(this.config.detailsOnClick.component, { ...this.config.detailsOnClick.componentData, event, calendar: true });
  }

  public setConfig(config: DataSourceConfig): void {
    this.config = config;
  }

  public getConfig(): DataSourceConfig {
    return this.config;
  }

  public getFiltersConfig(): FiltersConfig {
    return this.config.filters;
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/data-view-data-source/data-view-data-source.class.ts